
const PageErreur = () => {
        return (
            <div className='pageErreur'>
                
            </div>
        )
    }
    
export default PageErreur